export default __webpack_public_path__ + "static/media/curve-shape.3823aacb.png";